/* embla-era.js — Erawell Embla auto-init + retrofit adapters.
   Loads Embla core (+autoplay) from CDN if not already present. Fallback-safe:
   if Embla never loads, original layouts/scrollers keep working.

   1) Generic [data-embla] contract (same as embla-kp.js)
   2) Adapter: customer-reviews-carousel  (.reviews-container)
   3) Adapter: TB before/after cards      (.tb-ba__scroll)
   4) Adapter: product gallery main+thumbs (.product-gallery)
*/
(function () {
  var CDN_CORE = 'https://cdn.jsdelivr.net/npm/embla-carousel@8/embla-carousel.umd.js';
  var CDN_AUTO = 'https://cdn.jsdelivr.net/npm/embla-carousel-autoplay@8/embla-carousel-autoplay.umd.js';

  function injectBaseStyles() {
    if (document.getElementById('embla-era-base-styles')) return;
    var css =
      '[data-embla]{position:relative;}' +
      '[data-embla-viewport]{overflow:hidden;}' +
      '[data-embla-container]{display:flex;backface-visibility:hidden;touch-action:pan-y;}' +
      '[data-embla-dots]{display:flex;justify-content:center;align-items:center;gap:8px;flex-wrap:wrap;margin-top:14px;}' +
      '.embla__dot,[data-embla-dot]{appearance:none;-webkit-appearance:none;border:0;padding:0;margin:0;cursor:pointer;' +
      'width:8px;height:8px;border-radius:50%;background:rgba(60,40,80,0.22);transition:width .25s ease,background .25s ease;flex-shrink:0;}' +
      '.embla__dot.is-selected,[data-embla-dot][aria-selected="true"]{width:22px;border-radius:5px;background:#2d8b8b;}' +
      '[data-embla-prev],[data-embla-next]{cursor:pointer;}' +
      /* gallery retrofit: turn fade-swap into slide row */
      '.product-gallery [data-embla-container].shop-image-container,.product-gallery .shop-image-container[data-embla-container]{display:flex!important;}' +
      '.product-gallery [data-embla-container] > .shop-image-zoom-wrapper{display:block!important;opacity:1!important;position:relative!important;flex:0 0 100%;min-width:100%;}' +
      '.product-gallery [data-embla-container] > .shop-image-zoom-wrapper .shop-main-image{display:block!important;opacity:1!important;position:relative!important;width:100%;}' +
      '.product-gallery [data-embla-dots]{margin-top:18px!important;margin-bottom:6px;}' +
      '.era-thumbs-viewport{overflow:hidden;}' +
      '.era-thumbs-container{display:flex;gap:8px;touch-action:pan-y;}' +
      '.era-thumbs-container > *{flex:0 0 auto;}';
    var s = document.createElement('style');
    s.id = 'embla-era-base-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[data-embla-cdn="' + src + '"]')) { resolve(); return; }
      var s = document.createElement('script');
      s.src = src; s.async = true; s.setAttribute('data-embla-cdn', src);
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('embla cdn fail')); };
      document.head.appendChild(s);
    });
  }
  function ready() { return typeof window.EmblaCarousel !== 'undefined'; }

  /* ---------- generic [data-embla] init (markup contract) ---------- */
  function initOne(root) {
    if (root.__emblaInit) return;
    var viewport = root.querySelector('[data-embla-viewport]') || root.querySelector('.embla__viewport');
    if (!viewport) return;
    root.__emblaInit = true;

    var loop = root.getAttribute('data-embla-loop') !== 'false';
    var align = root.getAttribute('data-embla-align') || 'center';
    var autoplayMs = parseInt(root.getAttribute('data-embla-autoplay') || '0', 10);

    var _container = viewport.querySelector('[data-embla-container]') || viewport.firstElementChild;
    if (_container && !_container.__gapFixed) {
      var _cs = window.getComputedStyle(_container);
      var _gap = parseFloat(_cs.columnGap || _cs.gap || '0') || 0;
      if (_gap > 0) {
        _container.style.gap = '0px'; _container.style.columnGap = '0px'; _container.style.marginLeft = '0px';
        var _half = _gap / 2, _kids = _container.children;
        for (var _i = 0; _i < _kids.length; _i++) { _kids[_i].style.marginLeft = _half + 'px'; _kids[_i].style.marginRight = _half + 'px'; }
      }
      _container.__gapFixed = true;
    }

    var plugins = [];
    if (autoplayMs > 0 && window.EmblaCarouselAutoplay) {
      plugins.push(window.EmblaCarouselAutoplay({ delay: autoplayMs, stopOnInteraction: false, stopOnMouseEnter: true }));
    }
    var embla;
    try {
      embla = window.EmblaCarousel(viewport, { loop: loop, align: align, dragFree: false, containScroll: 'trimSnaps', skipSnaps: false }, plugins);
    } catch (e) { root.__emblaInit = false; return; }

    var dotsBox = root.querySelector('[data-embla-dots]');
    var dots = [];
    function buildDots() {
      if (!dotsBox) return;
      var snaps = embla.scrollSnapList();
      if (snaps.length <= 1) { dotsBox.innerHTML = ''; dotsBox.style.display = 'none'; dots = []; return; }
      dotsBox.style.display = '';
      if (dotsBox.querySelectorAll('[data-embla-dot]').length !== snaps.length) {
        dotsBox.innerHTML = '';
        snaps.forEach(function (_, i) {
          var b = document.createElement('button');
          b.setAttribute('data-embla-dot', ''); b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.className = 'embla__dot';
          b.addEventListener('click', function () { embla.scrollTo(i); });
          dotsBox.appendChild(b);
        });
      }
      dots = Array.prototype.slice.call(dotsBox.querySelectorAll('[data-embla-dot]'));
    }
    function selectDot() {
      buildDots();
      var i = embla.selectedScrollSnap();
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.classList.toggle('is-selected', on);
      });
    }
    var prev = root.querySelector('[data-embla-prev]');
    var next = root.querySelector('[data-embla-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); embla.scrollPrev(); }, { capture: true });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); embla.scrollNext(); }, { capture: true });
    embla.on('select', selectDot); embla.on('reInit', selectDot); selectDot();
    root.__embla = embla;
    function settle() { try { embla.reInit(); } catch (e) {} }
    root.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', settle, { once: true });
    });
    root.querySelectorAll('video').forEach(function (v) { v.addEventListener('loadedmetadata', settle, { once: true }); });
    [150, 500, 1200].forEach(function (ms) { setTimeout(settle, ms); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
  }

  /* helper: wrap an existing row element in a viewport div, mark contract attrs */
  function wrapAsEmbla(row, rootEl, opts) {
    if (rootEl.__emblaInit || row.__wrapped) return false;
    var viewport = document.createElement('div');
    viewport.setAttribute('data-embla-viewport', '');
    row.parentNode.insertBefore(viewport, row);
    viewport.appendChild(row);
    row.setAttribute('data-embla-container', '');
    row.style.overflow = 'visible';
    row.style.scrollSnapType = 'none';
    row.__wrapped = true;
    rootEl.setAttribute('data-embla', '');
    rootEl.setAttribute('data-embla-loop', opts.loop ? 'true' : 'false');
    rootEl.setAttribute('data-embla-align', opts.align || 'start');
    if (opts.autoplay) rootEl.setAttribute('data-embla-autoplay', String(opts.autoplay));
    return true;
  }

  /* ---------- adapter: customer reviews carousel ---------- */
  function adaptReviews() {
    document.querySelectorAll('.reviews-transformation-section').forEach(function (section) {
      try {
        if (section.__emblaInit) return;
        var row = section.querySelector('.reviews-container');
        if (!row || row.children.length < 2) return;
        Array.prototype.forEach.call(row.children, function (c) { c.style.flex = '0 0 auto'; });
        var prev = section.querySelector('.nav-button.prev');
        var next = section.querySelector('.nav-button.next');
        if (prev) prev.setAttribute('data-embla-prev', '');
        if (next) next.setAttribute('data-embla-next', '');
        wrapAsEmbla(row, section, { loop: true, align: 'center' });
        initOne(section);
      } catch (e) {}
    });
  }

  /* ---------- adapter: TB before/after cards ---------- */
  function adaptBeforeAfter() {
    document.querySelectorAll('.tb-ba').forEach(function (section) {
      try {
        if (section.__emblaInit) return;
        var row = section.querySelector('.tb-ba__scroll');
        if (!row || row.children.length < 2) return;
        Array.prototype.forEach.call(row.children, function (c) { c.style.flex = '0 0 auto'; });
        wrapAsEmbla(row, section, { loop: true, align: 'center', autoplay: 4000 });
        var dots = document.createElement('div');
        dots.setAttribute('data-embla-dots', '');
        section.querySelector('[data-embla-viewport]').insertAdjacentElement('afterend', dots);
        initOne(section);
      } catch (e) {}
    });
  }

  /* ---------- adapter: product gallery (main images + thumbnails) ---------- */
  function hijack(el, fn) {
    el.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); fn(e); }, { capture: true });
  }
  function adaptGallery() {
    document.querySelectorAll('.shop-product-carousel.product-gallery').forEach(function (gal) {
      try {
        if (gal.__emblaInit) return;
        var wrappers = gal.querySelectorAll('.shop-image-zoom-wrapper');
        if (wrappers.length < 2) return;
        var row = wrappers[0].parentElement; // .shop-image-container
        // evict non-slide children (arrow overlays etc.) so they don't become slides
        var evicted = [];
        Array.prototype.slice.call(row.children).forEach(function (ch) {
          if (!(ch.classList && ch.classList.contains('shop-image-zoom-wrapper'))) evicted.push(ch);
        });
        wrapAsEmbla(row, gal, { loop: true, align: 'center' });
        var viewport = gal.querySelector('[data-embla-viewport]');
        if (viewport) {
          viewport.style.position = 'relative';
          evicted.forEach(function (ch) { viewport.appendChild(ch); });
          // infinite-loop dots BELOW the on-screen image (auto-generated + synced by initOne)
          if (!gal.querySelector('[data-embla-dots]')) {
            var dotsBox = document.createElement('div');
            dotsBox.setAttribute('data-embla-dots', '');
            viewport.insertAdjacentElement('afterend', dotsBox);
          }
        }
        initOne(gal);
        var embla = gal.__embla;
        if (!embla) return;

        // arrows (mobile + desktop) — hijack ahead of any legacy handlers
        gal.querySelectorAll('.shop-mobile-prev-arrow,.shop-desktop-prev-arrow').forEach(function (b) { hijack(b, function () { embla.scrollPrev(); }); });
        gal.querySelectorAll('.shop-mobile-next-arrow,.shop-desktop-next-arrow').forEach(function (b) { hijack(b, function () { embla.scrollNext(); }); });

        // dots
        var dots = Array.prototype.slice.call(gal.querySelectorAll('.shop-dot'));
        dots.forEach(function (d, i) {
          var idx = parseInt(d.getAttribute('data-index') || i, 10);
          hijack(d, function () { embla.scrollTo(idx); });
        });

        // thumbnails: collect .shop-thumbnail nodes wherever they nest, wrap into a strip, sync both ways
        var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.shop-thumbnail'));
        function idxOf(th, fallback) {
          var d = parseInt(th.getAttribute('data-index'), 10);
          return isNaN(d) ? fallback : d;
        }
        var thumbsEmbla = null;
        if (thumbs.length > 1 && window.EmblaCarousel) {
          try {
            var tParent = thumbs[0].parentElement;
            var tView = document.createElement('div'); tView.className = 'era-thumbs-viewport';
            var tCont = document.createElement('div'); tCont.className = 'era-thumbs-container';
            tParent.insertBefore(tView, thumbs[0]);
            tView.appendChild(tCont);
            thumbs.forEach(function (th) { tCont.appendChild(th); });
            thumbsEmbla = window.EmblaCarousel(tView, { loop: false, align: 'start', dragFree: true, containScroll: 'keepSnaps' });
          } catch (e) { thumbsEmbla = null; }
        }
        function syncActive() {
          var i = embla.selectedScrollSnap();
          thumbs.forEach(function (th, k) {
            var on = idxOf(th, k) === i;
            th.classList.toggle('active', on);
            var sq = th.querySelector('.thumb-square');
            if (sq) sq.classList.toggle('active', on);
          });
          dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
          if (thumbsEmbla) { try { thumbsEmbla.scrollTo(Math.max(0, i - 1)); } catch (e) {} }
        }
        thumbs.forEach(function (th, k) { hijack(th, function () { embla.scrollTo(idxOf(th, k)); }); });
        embla.on('select', syncActive); embla.on('reInit', syncActive); syncActive();
      } catch (e) {}
    });
  }

  function initAll() {
    injectBaseStyles();
    function go() {
      adaptReviews();
      adaptBeforeAfter();
      adaptGallery();
      document.querySelectorAll('[data-embla]').forEach(initOne);
    }
    if (ready()) { go(); return; }
    loadScript(CDN_CORE)
      .then(function () { return loadScript(CDN_AUTO).catch(function () {}); })
      .then(function () { if (ready()) go(); })
      .catch(function () { /* originals keep working */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 50); });
})();
